import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=8aed800a&scoped=true"
import script from "./CartIcon.vue?vue&type=script&lang=js"
export * from "./CartIcon.vue?vue&type=script&lang=js"
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=8aed800a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aed800a",
  null
  
)

export default component.exports